module.exports = __webpack_public_path__ + "static/media/WizardOfOz2.10941de2.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/WizardOfOz2.JPG
// module id = 70
// module chunks = 0